.actions {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
  height: 100%;
}
